import { submissionGroupApi } from './apis';
import { convertToQueryString } from '@utils';
import {
  CreateSubmissionGroupRequestInterface,
  GenericItemsResponseInterface,
  SubmissionGroupEntityInterface,
  SubmissionGroupQueryInterface,
  UpdateSubmissionGroupRequestInterface,
} from '@types';

export const getAllSubmissionGroups = async (
  query: SubmissionGroupQueryInterface
): Promise<GenericItemsResponseInterface<SubmissionGroupEntityInterface>> => {
  const response = await submissionGroupApi.get(`/${convertToQueryString(query)}`);

  return response.data;
};

export const createSubmissionGroup = async (
  data: CreateSubmissionGroupRequestInterface
): Promise<void> => {
  const response = await submissionGroupApi.post('/', data);
  return response.data;
};

export const deleteSubmissionGroup = async (id: string): Promise<void> => {
  const response = await submissionGroupApi.delete(`/${id}`);
  return response.data;
};

export const updateSubmissionGroup = async (
  id: string,
  data: UpdateSubmissionGroupRequestInterface
): Promise<void> => {
  const response = await submissionGroupApi.put(`/${id}`, data);
  return response.data;
};

export const getAllNotDeletedGroups = async (): Promise<
  GenericItemsResponseInterface<SubmissionGroupEntityInterface>
> => {
  const response = await submissionGroupApi.get('/all');
  return response.data;
};
